import { render } from "./insure-team-bill.vue?vue&type=template&id=80350a9a&scoped=true&ts=true"
import script from "./insure-team-bill.vue?vue&type=script&lang=ts"
export * from "./insure-team-bill.vue?vue&type=script&lang=ts"

import "./insure-team-bill.vue?vue&type=style&index=0&id=80350a9a&lang=stylus&scoped=true"

import exportComponent from "/Users/rong.chen/data/zd/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80350a9a"]])

export default __exports__